<!--
 * @Author       : 花裤衩<白永明><yongming.bai@outlook.com>
 * @Date         : 2026-01-07 15:58:04 +0800
 * @LastEditors  : 花裤衩<白永明><yongming.bai@outlook.com>
 * @LastEditTime : 2026-01-16 09:55:51 +0800
 * @FilePath     : /ai-agent-lumina/src/components/global/title-bar/src/izt-title-bar.vue
 * @Description  : 带标题的组件
-->
<style lang="scss" scoped>
.izt-title-bar-container {
  background-color: var(--izt-background-color);
  box-sizing: border-box;

  .title-and-operation {
    padding: 0 30px;
    padding-top: 29px;
    padding-bottom: 18px;
    font-size: 28px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .operation-left {
      display: flex;
      align-items: center;
      .title-text {
        font-weight: bold;
        font-size: 36px;
        color: var(--izt-mirror-color-85);
      }
    }
    .operation-right {
      height: 40px;
      position: relative;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
}
</style>

<template>
  <div class="izt-title-bar-container">
    <div class="title-and-operation">
      <div class="operation-left">
        <span class="title-text">{{title}}</span>
        <slot name="left"/>
      </div>
      <div class="operation-right">
        <slot name="right"/>
      </div>
    </div>

    <slot />
  </div>
</template>

<script setup name="izt-title-bar">
  defineOptions({ name: 'izt-title-bar' })
  defineProps({
    title: {
      type: String,
      default: ''
    }
  })
</script>